import { render, staticRenderFns } from "./recommenddetail.vue?vue&type=template&id=31ccdf96&scoped=true"
import script from "./recommenddetail.vue?vue&type=script&lang=js"
export * from "./recommenddetail.vue?vue&type=script&lang=js"
import style0 from "./recommenddetail.vue?vue&type=style&index=0&id=31ccdf96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ccdf96",
  null
  
)

export default component.exports